import { RecConfig, getParse_rec_list } from './RecConfig';

// 购物车
const Config = {
  'Cart.header.edit': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车编辑模式入口',
    c: {
      type: 'variable',
      func: `function getC(traceData) {
        return traceData.editStatus ? 'edit_finish' : 'edit'
      }`,
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Cart.header.notify': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车顶部公告',
    c: {
      type: 'constant',
      value: 'announcement',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Cart.header.topOffer': {
    operation: ['VISIBLE'],
    title: '购物车顶部包邮信息',
    c: {
      type: 'constant',
      value: 'top_offer',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.index + 1;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        return 'offer_type=' + traceData.type;
      }`,
    },
  },
  'Cart.header.addOn': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车分组去凑单按钮',
    c: {
      type: 'constant',
      value: 'add_on',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const url = traceData.url || '';
        return 'u=' + url;
      }`,
    },
  },
  'Cart.noresult.gotoMain': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车无商品时随便看看功能',
    c: {
      type: 'constant',
      value: 'gotomain',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const url = traceData.url || '';
        return 'u=' + url;
      }`,
    },
  },
  'Cart.list.cartItemDetail': {
    operation: ['TOUCH'],
    title: '购物车商品列表元素',
    c: {
      type: 'constant',
      value: 'cart_to_detail',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        const url = traceData.url;
        return 'main_skus=' + (data.ssuId || '') + '&product_id=' + (data.itemId || '') + '&next=' + 'product.' + (data.itemId || '') + '&u=' + url;
      }`,
    },
  },
  'Cart.list.cartItemChildren': {
    operation: ['TOUCH'],
    title: '购物车商品列表子元素',
    c: {
      type: 'variable',
      func: function getC(traceData) {
        const data = traceData.data;
        // if (data.showType === 'bargain') {
        //   return 'product_card_add';
        // } else
        if (data.showType === 'gift') {
          return 'product_card_gift';
        } else if (data.showType === 'insure' || data.showType === 'virtualBindProp') {
          return 'product_card_service';
        }
        return 'cart_to_detail';
      },
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.statIndex ? traceData.statIndex : traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        const parentData = traceData.parentData || {};
        const url = traceData.url;
        const type = data.showType === 'gift' ? (Array.isArray(data.tags) && data.tags.indexOf('PRO_MEMBER_GIFT') > -1 ? 2 : 1) : null;
        return 'main_skus=' + parentData.ssuId + '&skus=' + (data.serviceSsuId || data.ssuId) + '&next=' + 'product.' + (data.itemId || '') + '&product_id=' + (data.itemId || '') + '&u=' + url + (type ? ('&type=' + type) : ''); 
      }`,
    },
  },
  // 同上，多了曝光
  'Cart.list.cartItemChildren.add': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车商品列表子元素的 加价购',
    c: {
      type: 'variable',
      func: function getC(traceData) {
        // const data = traceData.data;
        // if (data.showType === 'bargain') {
        return 'product_card_add';
        // } else if (data.showType === 'gift') {
        //   return 'product_card_gift';
        // } else if (data.showType === 'insure' || data.showType === 'virtualBindProp') {
        //   return 'product_card_service';
        // }
        // return 'cart_to_detail';
      },
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.statIndex ? traceData.statIndex : traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        const parentData = traceData.parentData || {};
        const url = traceData.url;
        const type = data.showType === 'gift' ? (Array.isArray(data.tags) && data.tags.indexOf('PRO_MEMBER_GIFT') > -1 ? 2 : 1) : null;
        return 'main_skus=' + parentData.ssuId + '&skus=' + (data.serviceSsuId || data.ssuId) + '&next=' + 'product.' + (data.itemId || '') + '&product_id=' + (data.itemId || '') + '&u=' + url + (type ? ('&type=' + type) : ''); 
      }`,
    },
  },

  'Cart.list.cartGiftEdit': {
    operation: ['TOUCH'],
    title: '赠品修改按钮',
    c: {
      type: 'constant',
      value: 'product_card_gift_edit',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.statIndex ? traceData.statIndex : traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        const item = traceData.item || {};
        const type = Array.isArray(data.tags) && data.tags.indexOf('PRO_MEMBER_GIFT') > -1 ? 2 : 1;
        return 'main_skus=' + data.ssuId + '&product_id=' + data.itemId + '&skus=' + item.ssuId + '&type=' + type;
      }`,
    },
  },
  'Cart.list.cartItemFavor': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车列表收藏按钮',
    c: {
      type: 'variable',
      func: `function getC(traceData) {
        if (traceData.isMain) {
          return 'to_favor';
        }
        return 'byproduct_to_favor';
      }`,
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.statIndex ? traceData.statIndex : traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        return 'main_skus=' + data.ssuId + '&product_id=' + data.itemId + '&next=' + 'product.' + data.itemId;
      }`,
    },
  },
  'Cart.list.cartItemDelete': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车列表收藏按钮',
    c: {
      type: 'variable',
      func: `function getC(traceData) {
        if (traceData.isMain) {
          return 'to_delete';
        }
        return 'byproduct_to_delete';
      }`,
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.statIndex ? traceData.statIndex : traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        return 'main_skus=' + data.ssuId + '&product_id=' + data.itemId + '&next=' + 'product.' + data.itemId;
      }`,
    },
  },

  'Cart.list.customizationTouch': {
    operation: ['TOUCH'],
    title: '查看定制信息',
    c: {
      type: 'constant',
      value: 'customization',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data;
        return 'main_skus=' + data.ssuId;
      }`,
    },
  },

  'Cart.list.invalidFavor': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车商品列表失效商品全部收藏按钮',
    c: {
      type: 'constant',
      value: 'invalid_favor',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Cart.list.invalidDelete': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车商品列表失效商品全部删除按钮',
    c: {
      type: 'constant',
      value: 'invalid_delete',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Cart.list.vipCoupon': {
    operation: ['TOUCH'],
    title: '购物车营销劵领取',
    c: {
      type: 'variable',
      func: `function getC(traceData) {
        const coupon = traceData.coupon;
        return coupon.fetchAbleState ? 'get_coupon' : 'use_coupon';
      }`,
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const coupon = traceData.coupon;
        const url = traceData.url || '';
        return 'coupon_id=' + coupon.couponKey + (coupon.fetchAbleState ? '' : ('&u=' + url));
      }`,
    },
  },

  'Cart.bottomBar.ReceiptList': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车底栏明细入口',
    c: {
      type: 'constant',
      value: 'to_receipt_list',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Cart.bottomBar.selectToFavor': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车底栏编辑模式移入收藏功能',
    c: {
      type: 'constant',
      value: 'select_to_favor',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Cart.bottomBar.selectToDelete': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车底栏编辑模式删除商品功能',
    c: {
      type: 'constant',
      value: 'select_to_delete',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Cart.bottomBar.cartCheckAll': {
    operation: ['TOUCH'],
    title: '购物车底栏全选按钮',
    c: {
      type: 'constant',
      value: 'cart_check_all',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        return 'status=' + traceData.status;
      }`,
    },
  },

  'Cart.serviceModal.serviceIntroduce': {
    operation: ['TOUCH'],
    title: '购物车服务介绍',
    c: {
      type: 'constant',
      value: 'purchase_service_introduction',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const item = traceData.item || {};
        return 'purchase_state=' + JSON.stringify(item) + '&u=' + item.serviceUrl;
      }`,
    },
  },

  'Cart.serviceModal.termsService': {
    operation: ['TOUCH'],
    title: '购物车服务条款',
    c: {
      type: 'constant',
      value: 'purchase_terms_service',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const option = traceData.option || {};
        const item = (option.list[option.selectedIndex] && option.list[option.selectedIndex].data) || {};
        const clause = traceData.clause || {};
        return 'type_name=' + option.typeName + '&desc=' + (item.serviceShortName || item.propShortName) + '&u=' + clause.url;
      }`,
    },
  },

  'Cart.serviceModal.submit': {
    operation: ['TOUCH', 'visible'],
    title: '购物车服务弹层确定按钮',
    c: {
      type: 'constant',
      value: 'purchase_service_select',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data;
        const properties = traceData.properties;
        const skus = []
        for (let i = 0; i < properties.length; ++i) {
          const property = properties[i];
           if (property.selectedIndex === -1) {
              continue;
           }

          if (property.source === 'service') {
            const selectProperty = property.list[property.selectedIndex];
            const value = selectProperty.data;
            skus.push(value.serviceSsuId);
          } else if (property.source === 'virtual') {
            const selectProperty = property.list[property.selectedIndex];
            const value = selectProperty.data;
            skus.push(value.ssuId);
          }
        }
        return 'main_skus=' + data.ssuId + '&skus=' + skus.join(',');
      }`,
    },
  },

  'Cart.discountModal.receiptListMore': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车明细弹层优惠详情',
    c: {
      type: 'constant',
      value: 'receipt_list_more',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Cart.giftModal.confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车赠品换购弹层确认按钮',
    c: {
      type: 'constant',
      value: 'choose_gift_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data;
        const actId = traceData.actId || '';
        const tag = traceData.tag || '';
        const selectMap = traceData.selectMap;
        const skus = [];
        const type = Array.isArray(data.tags) && data.tags.indexOf('PRO_MEMBER_GIFT') > -1 ? 2 : 1;

        for (const groupId in selectMap) {
          const group = selectMap[groupId];
          for (const ssuId in group) {
            if (group[ssuId]) {
              skus.push(ssuId);
            }
          }
        }

        return 'main_skus=' + data.ssuId + '&skus=' + skus.join(',') + '&activity_id=' + actId + '&tag=' + tag + '&type=' + type;
      }`,
    },
  },

  'Cart.giftModal.giftList': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '赠品弹层赠品列表',
    c: {
      type: 'constant',
      value: 'gift_lists',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.index || '0'
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const url = traceData.url || '';
        const item = traceData.item || {};
        const tag = traceData.tag || '';
        return 'u=' + url + '&tag=' + tag + '&product_id=' + item.ssuId + '&next=product.' + item.ssuId;
      }`,
    },
  },

  'Cart.giftModal.giftPopup': {
    operation: ['VISIBLE'],
    title: '赠品弹窗弹出事件',
    c: {
      type: 'constant',
      value: 'gift_popup',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },

  'Cart.giftModal.giftSelect': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '赠品弹层勾选事件',
    c: {
      type: 'constant',
      value: 'gift_select',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.index || '0'
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const url = traceData.url || '';
        const item = traceData.item || {};
        const tag = traceData.tag || '';
        const actId = traceData.actId || '';
        return 'u=' + url + '&tag=' + tag + '&product_id=' + item.ssuId + '&activity_id=' + actId;
      }`,
    },
  },

  'Cart.giftModal.closeModal': {
    c: {
      type: 'constant',
      value: 'close_gift_popup',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const actId = traceData.actId || '';
        const tag = traceData.tag || '';
        return 'activity_id=' + actId + '&tag=' + tag;
      }`,
    },
  },

  'Cart.bargainModal.confirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车加价购弹层确认按钮',
    c: {
      type: 'constant',
      value: 'done_markup',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return (10000 + traceData.index + 1).toString();
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const data = traceData.data || {};
        const item = traceData.item || {};
        return 'main_skus=' + data.ssuId + '&skus=' + item.ssuId;
      },
    },
  },

  'Cart.bargainModal.item': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '购物车加价购弹层单个item的点击和曝光',
    c: {
      type: 'constant',
      value: 'markup',
    },
    d: {
      type: 'variable',
      func: function getIid(traceData) {
        return (10000 + traceData.index + 1).toString();
      },
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const data = traceData.data || {};
        const item = traceData.item || {};
        return 'main_skus=' + data.ssuId + '&skus=' + item.ssuId;
      },
    },
  },

  'Cart.item.serviceInfo': {
    operation: ['TOUCH'],
    title: '购物车商品列表选购服务，赠品，加价购',
    c: {
      type: 'variable',
      func: `function getC(traceData) {
        return traceData.c;
      }`,
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.index;
      }`,
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const c = traceData.c;
        const data = traceData.data || {};
        const item = traceData.item || {};
        const mode = item?.selectInfo?.length > 0 ? (item.checked ? 'reselect' : 'multiple') : 'select';
        if (c === 'product_service_gift') {
          return 'main_skus=' + data.ssuId + '&skus=' + item.ssuId;
        } else if (c === 'product_service_add') {
          return 'main_skus=' + data.ssuId + '&skus=' + item.ssuId + '&mode=' + mode;
        } else if (c === 'product_service_service') {
          return 'main_skus=' + data.ssuId + '&skus=';
        }
        return '';
      },
    },
  },
  // 换购的埋点同上Cart.item.serviceInfo，不过多了曝光
  'Cart.item.serviceInfo.add': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车商品列表选购服务，赠品，加价购',
    c: {
      type: 'variable',
      func: `function getC(traceData) {
        return traceData.c;
      }`,
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return traceData.index;
      }`,
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const c = traceData.c;
        const data = traceData.data || {};
        const item = traceData.item || {};
        const mode = item?.selectInfo?.length > 0 ? (item.checked ? 'reselect' : 'multiple') : 'select';
        // if (c === 'product_service_gift') {
        //   return 'main_skus=' + data.ssuId + '&skus=' + item.ssuId;
        // } else if (c === 'product_service_add') {
        return 'main_skus=' + data.ssuId + '&skus=' + item.ssuId + '&mode=' + mode + '&activity_id=' + item?.actId;
        // } else if (c === 'product_service_service') {
        //   return 'main_skus=' + data.ssuId + '&skus=';
        // }
        // return '';
      },
    },
  },

  'Cart.item.favor': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车商品收藏',
    c: {
      type: 'constant',
      value: 'to_favor',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        const data = traceData.data;
        return data.statIndex;
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data;
        return 'main_skus=' + data.ssuId + '&product_id=' + data.itemId;
      }`,
    },
  },
  'Cart.item.delete': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车商品收藏',
    c: {
      type: 'constant',
      value: 'to_favor',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        const data = traceData.data;
        return data.statIndex;
      }`,
    },
  },
  'Cart.bottom.checkout': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '购物车底部结算按钮',
    c: {
      type: 'constant',
      value: 'checkout',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const url = traceData.url || '';
        return 'u=' + url;
      }`,
    },
  },
  // 公共推荐部分的埋点
  ...RecConfig,

  'Cart.list.cardVisible': {
    operation: ['VISIBLE'],
    title: '购物侧大列表的曝光',
    c: {
      type: 'constant',
      value: 'recommend_list',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        if(traceData.type === 'rec_list') {
          const productId = traceData.data.goods.itemId;
          return 'product_id=' + productId + '&next=product.' + productId;
        }
        return 1;
      }`,
    },
    getParse_rec_list,
    getParse_vip_coupon: {
      type: 'variable',
      func: function getVipCoupon(item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [];
        if (Array.isArray(item.item) && item.item.length > 0) {
          item.item.forEach((coupon, index) => {
            result.push({
              type: 'vip_coupon',
              item: coupon,
              isViewable: true,
              key: coupon.couponInfo.couponKey,
              index: index,
              page: pageName,
              b: pageName,
              c: 'end_coupon_lists',
              d: index + 1,
              area: 'end_coupon_lists',
              iid: 'coupon_id=' + coupon.couponInfo.configId,
            });
          });
        }
        return result;
      },
    },
    getParse_product: {
      type: 'variable',
      func: function getProduct(item = {}, visibleData, args) {
        const { pageName } = args;
        const result = [];
        // 商品信息，不是section的header与footer
        if (item.item.productName) {
          const obj = {
            type: 'product',
            item: item.item,
            isViewable: true,
            key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey,
            index: item.index,
            page: pageName,
            b: pageName,
            c: 'cart_to_detail',
            d: item.item.statIndex,
            area: 'cart_to_detail',
            iid:
              'main_skus=' +
              item.item.ssuId +
              '&product_id=' +
              item.item.itemId +
              '&next=' +
              'product.' +
              item.item.itemId +
              '&u=' +
              `https://m.xiaomiyoupin.com/mfbs/mstd/product?commodityId=${item.item.itemId}&goodsId=${item.item.ssuId}`,
          };

          result.push(obj);

          if (item.item.hasMoreThanOnePid) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-switch_sku',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'switch_sku',
              d: item.item.statIndex,
              area: 'switch_sku',
              iid: 'main_skus=' + item.item.ssuId,
            });
          }

          // 中台打标
          if (item.item.tags && item.item.tags.length) {
            for (let i = 0; i < item.item.tags.length; ++i) {
              result.push({
                type: 'product',
                item: item.item,
                isViewable: true,
                key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-product_labeling',
                index: item.index,
                page: pageName,
                b: pageName,
                c: 'product_labeling',
                d: i + 1,
                area: 'product_labeling',
                iid: 'main_skus=' + item.item.ssuId + '&type=' + encodeURIComponent(item.item.tags[i].name),
              });

              if (item.item.tags[i].tag === 'fcode') {
                result.push({
                  type: 'product',
                  item: item.item,
                  isViewable: true,
                  key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
                  index: item.index,
                  page: pageName,
                  b: pageName,
                  c: 'activity_discount',
                  d: 1,
                  area: 'activity_discount',
                  iid: 'main_skus=' + item.item.ssuId + '&type=' + encodeURIComponent('F码'),
                });
              }
            }
          }

          const extraActs = item.item.extraActs || {};

          if (extraActs.actPrefertialInfo) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'activity_discount',
              d: 1,
              area: 'activity_discount',
              iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.actPrefertialInfo.tagTxt,
            });
          }

          if (extraActs.fsbuy) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'activity_discount',
              d: 1,
              area: 'activity_discount',
              iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.fsbuy.tagTxt,
            });
          }

          // 有品赠品
          if (extraActs.buyGift && extraActs.buyGift.length > 0) {
            extraActs.buyGift.forEach((gift, index) => {
              result.push({
                type: 'product',
                item: item.item,
                isViewable: true,
                key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-product_service_gift',
                index: item.index,
                page: pageName,
                b: pageName,
                c: 'product_service_gift',
                d: item.item.statIndex * 10000 + 1 + index,
                area: 'product_service_gift',
                iid: 'main_skus=' + item.item.ssuId + '&skus=' + gift.ssuId,
              });
            });
          }

          if (extraActs.buylimitInfo) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'activity_discount',
              d: 1,
              area: 'activity_discount',
              iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.buylimitInfo.tagTxt,
            });
          }

          if (extraActs.secKill) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'activity_discount',
              d: 1,
              area: 'activity_discount',
              iid: 'main_skus=' + item.item.ssuId + '&type=' + extraActs.secKill.tagTxt,
            });
          }

          // 合约机
          if (item.item.properties.miContractInfo) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-activity_discount',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'activity_discount',
              d: 1,
              area: 'activity_discount',
              iid: 'main_skus=' + item.item.ssuId + '&type=' + encodeURIComponent('合约机'),
            });
          }

          if (item.item.checkoutPrice) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-hand_price',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'hand_price',
              d: '1',
              area: 'hand_price',
              iid: 'main_skus=' + item.item.ssuId,
            });
          } else if (item.item.addCartPriceReduce > 0) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-cut_price_inform',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'cut_price_inform',
              d: '1',
              area: 'cut_price_inform',
              iid: '',
            });
          }

          if (item.item.customInfo) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-customization',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'customization',
              d: '1',
              area: 'customization',
              iid: 'main_skus=' + item.item.ssuId,
            });
          }

          const nextAction = item.item.nextAction || [];
          const isRenderBtn = nextAction.indexOf('EDITABLE') > -1 || item.item.canChangeNum;

          if (isRenderBtn) {
            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-goodsnum_minus',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'goodsnum_minus',
              d: '1',
              area: 'goodsnum_minus',
              iid: 'main_skus=' + item.item.ssuId,
            });

            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-goodsnum_plus',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'goodsnum_plus',
              d: '1',
              area: 'goodsnum_plus',
              iid: 'main_skus=' + item.item.ssuId,
            });

            result.push({
              type: 'product',
              item: item.item,
              isViewable: true,
              key: item.item.ssuId + '-' + item.item.itemId + '-' + item.item.cartKey + '-goodsnum_adjust',
              index: item.index,
              page: pageName,
              b: pageName,
              c: 'goodsnum_adjust',
              d: '1',
              area: 'goodsnum_adjust',
              iid: 'main_skus=' + item.item.ssuId,
            });
          }
        }

        return result;
      },
    },
  },

  'Card.list.switchSkuTouch': {
    operation: ['TOUCH'],
    title: '商品卡片SKU切换弹层开关点击',
    c: {
      type: 'constant',
      value: 'switch_sku',
    },
    d: {
      type: 'variable',
      func: `function getD(traceData) {
        return (traceData.data && traceData.data.statIndex) || '1';
      }`,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {}
        return 'main_skus=' + data.ssuId;
      }`,
    },
  },

  'Cart.list.goodsNumMinus': {
    operation: ['TOUCH'],
    title: '购物车商品卡片数量降低按钮',
    c: {
      type: 'constant',
      value: 'goodsnum_minus',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data;
        return 'main_skus=' + data.ssuId;
      }`,
    },
  },

  'Cart.list.goodsNumPlus': {
    operation: ['TOUCH'],
    title: '购物车商品卡片数量增加按钮',
    c: {
      type: 'constant',
      value: 'goodsnum_plus',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data;
        return 'main_skus=' + data.ssuId;
      }`,
    },
  },

  'Cart.skuSelectModal.specificationsConfirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '选择商品规格弹窗，确认按钮',
    c: {
      type: 'constant',
      value: 'select_specifications_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        const selectRes = traceData.selectRes || {};
        return 'main_skus=' + selectRes.selectedPid;
      }`,
    },
  },

  'Cart.skuSelectModal.packageConfirm': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '选择套装商品规格弹窗，确认按钮',
    c: {
      type: 'constant',
      value: 'select_package_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
        const data = traceData.data || {};
        const selectRes = traceData.selectRes || {};
        const subSelectedPid = selectRes.subSelectedPid || [] 
        return 'main_skus=' + data.ssuId + '&skus=' + subSelectedPid.join(','); 
      }`,
    },
  },
  'Cart.login.login_bar': {
    operation: ['TOUCH'],
    title: '去登录',
    c: {
      type: 'constant',
      value: 'cart_login',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 天降红包
  'Cart.fromSkyModal.receiveVisible': {
    operation: ['VISIBLE'],
    title: '天降红包领券弹层',
    c: {
      type: 'constant',
      value: 'award_pop_up',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const {
          couponIds = '', // 券id集合
          type = '', // 是否使用AI类型
          pop_status = '',
        } = traceData;
        return `coupon_ids=${couponIds}&type=${type}&pop_status=${pop_status}`;
      },
    },
  },
  // 灌券
  'Cart.fromSkyModal.useVisible': {
    operation: ['VISIBLE'],
    title: '天降红包灌券弹层',
    c: {
      type: 'constant',
      value: 'pour_pop_up',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const {
          couponIds = '', // 券id集合
          type = '', // 是否使用AI类型
        } = traceData;
        return `coupon_ids=${couponIds}&type=${type}`;
      },
    },
  },
};

export default Config;
